import { Link } from "react-router-dom";

export const SessionTypeCard = ({ image, title, description, type }) => (
  <div data-testid={`session-type-card-${type}`} className="group relative rounded-2xl overflow-hidden h-[420px]">
    <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
    <div className="absolute bottom-0 left-0 p-7 w-full">
      <h3 className="text-clean-white font-extrabold uppercase text-xl mb-2 tracking-tight">{title}</h3>
      <p className="text-clean-white/80 text-sm font-medium mb-5 max-w-[280px]">{description}</p>
      <Link to={`/find-a-session?type=${type}`} data-testid={`explore-${type}`}>
        <button className="border-2 border-clean-white text-clean-white text-xs font-bold tracking-widest px-6 py-3 rounded-full hover:bg-clean-white hover:text-midnight-black transition-colors">EXPLORE</button>
      </Link>
    </div>
  </div>
);
